import { useUserContext } from '@/contexts/UserContext.tsx'
import { getMutation } from '@/requests/apollo/mutation.ts'
import { ITERATION_COMMAND_META } from '@/requests/apollo/schema.ts'
import { getExecuteTemplate } from '@/requests/apollo/templates.ts'
import { useQueryIterations, useQueryProjectMeta } from '@/requests/queries/useQueryProject.ts'

export const useMutateIteration = () => {
  // biome-ignore lint/style/noNonNullAssertion: This is guaranteed to be non-null
  const user = useUserContext().user!
  const { projectMeta } = useQueryProjectMeta()
  const { iterations } = useQueryIterations()

  const [execute] = getMutation('Iteration', ITERATION_COMMAND_META)

  return {
    mutate: (number: number, teamStrength: number) => {
      const iteration = iterations.find((iteration) => iteration.number === number)
      const { variables, optimisticResponse } = getExecuteTemplate<Iteration>(
        projectMeta,
        'ITERATION_UPDATE',
        user.id,
        {
          number,
          teamStrength,
        },
        {
          ...iteration,
          teamStrength,
        },
      )

      return execute({
        variables,
        optimisticResponse,
      })
    },
  }
}
